export function itemHasBackendImage(item) {
  return String(item?.image ?? '').trim() !== '';
}

export function isGeneratedFallbackImageUrl(url) {
  const value = String(url || '').trim().toLowerCase();
  return !value || value.includes('/img/food.svg') || value.includes('general_banner');
}

export function resolveItemColor(item) {
  return String(item?.color ?? '').trim();
}

export function readableTextOn(hexColor) {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hexColor || '').trim());
  if (!m) return '#ffffff';
  let h = m[1];
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const lin = (v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
  const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return luminance > 0.55 ? '#1a1a1a' : '#ffffff';
}

export function itemInitialFromLabel(label) {
  const ch = String(label || '?').trim().charAt(0);
  return ch ? ch.toUpperCase() : '?';
}

export function itemColorStyle(item) {
  const color = resolveItemColor(item);
  return color ? { backgroundColor: color, color: readableTextOn(color) } : undefined;
}
